export const GA_TRACKING_ID = 'UA-129901184-2'
